import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { generateQueryString, updateQueryParams } from "@/scripts/common/util";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import Datepicker from "vanillajs-datepicker/Datepicker";
import "vanillajs-datepicker/css/datepicker.css";

const pageSection = document.querySelector(".page-section");
const form = document.querySelector(".filter-form");
const checkboxFilterForm = document.querySelector(".checkbox-filter-form");
const datepickerEl = document.querySelector("[data-datepicker]");

let datepicker;

const setupDatepicker = () => {
  if (!datepickerEl) {
    return;
  }

  const selectedDate = datepickerEl.dataset.date;
  const activeDates = JSON.parse(datepickerEl.dataset.dates);

  const opts = {
    minDate: new Date(),
    maxView: 0,
    todayHighlight: true,
    prevArrow: `
      <svg viewBox="0 0 24 24">
       <path fill="currentColor" d="M9.087 11.773 14.316 6.097a.28.28 0 0 1 .42-.003l.177.191a.343.343 0 0 1 0 .458L10.07 11.998l4.842 5.259a.343.343 0 0 1 0 .457l-.176.191a.281.281 0 0 1-.421 0L9.087 12.23a.343.343 0 0 1 0-.457Z"/>
      </svg>
    `,
    nextArrow: `
      <svg viewBox="0 0 24 24">
        <path d="M14.9127 11.7725L9.68421 6.09717C9.56781 5.96806 9.37956 5.96806 9.26315 6.09449L9.08731 6.28545C8.9709 6.41187 8.9709 6.61631 9.08731 6.7427L13.9294 11.9985L9.08731 17.257C8.9709 17.3834 8.9709 17.5878 9.08731 17.7142L9.26315 17.9052C9.37957 18.0316 9.56781 18.0316 9.68421 17.9052L14.9127 12.2298C15.0291 12.1034 15.0291 11.899 14.9127 11.7725Z" fill="currentColor"/>
      </svg>
    `,
    datesDisabled: (date) => {
      const isActive = activeDates.some(
        (dateStr) => new Date(dateStr).toISOString().split("T")[0] === date.toISOString().split("T")[0],
      );

      return !isActive;
    },
  };

  datepicker = new Datepicker(datepickerEl, opts);

  if (selectedDate) {
    datepicker.setDate(Datepicker.parseDate(selectedDate, "yyyy-mm-dd"));
  }

  datepickerEl.addEventListener("changeDate", (e) => {
    const date = e.detail.date;

    handleDateChange(date);
  });
};

const handleDateChange = (date) => {
  const formattedDate = Datepicker.formatDate(date, "yyyy-mm-dd");
  const url = `${form.action}?date=${formattedDate}`;

  window.history.replaceState({}, "", url);

  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  updateResults();
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterLink = (e) => {
  e.preventDefault();

  const url = e.delegateTarget.href;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
  datepicker.setDate({ clear: true });

  if (checkboxFilterForm) {
    checkboxFilterForm.querySelectorAll("input:checked").forEach((x) => (x.checked = false));
  }

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 48);
    pageSection.classList.add("is-filtered");
  } else {
    pageSection.classList.remove("is-filtered");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-link", "click", handleFilterLink);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }

  setupDatepicker();
});
